import { TranslationKeys } from 'locales/translationKeys'
import beefDisplay from '../../../../public/assets/recipes/frozen/beef-ingredients-display.webp'
import beefBowl from '../../../../public/assets/recipes/frozen/beef-bowl.webp'
import chickenBowl from '../../../../public/assets/recipes/frozen/chicken-bowl.webp'
import { Proteins } from 'models/Pet'
import { RecipeDetailHeroProps } from '../FreezeDriedRecipeDetail/components/RecipeDetailHero'
import { RecipeDetailBenefitsProps } from '../FreezeDriedRecipeDetail/components/RecipeDetailBenefits'
import chickenPouch from '../../../../public/assets/recipes/frozen/frozen-chicken-pouch-white-wrapper.webp'
import duckBowl from '../../../../public/assets/recipes/frozen/duck-bowl.webp'
import duckPouch from '../../../../public/assets/recipes/frozen/frozen-duck-pouch-white-wrapper.webp'
import lambPouch from '../../../../public/assets/recipes/frozen/frozen-lamb-pouch-white-wrapper.webp'
import lambBowl from '../../../../public/assets/recipes/frozen/lamb-bowl.webp'
import turkeyBowl from '../../../../public/assets/recipes/frozen/turkey-bowl.webp'
import turkeyPouch from '../../../../public/assets/recipes/frozen/frozen-turkey-pouch-white-wrapper.webp'
import venisonPouch from '../../../../public/assets/recipes/frozen/frozen-venison-pouch-white-wrapper.webp'
import { NUTRITION_PATTIES } from 'fixtures/nutrition'

type RecipeType = {
  breadcrumb: TranslationKeys
  hero: RecipeDetailHeroProps
  benefits: RecipeDetailBenefitsProps
  ingredients: {
    label: TranslationKeys
    description: TranslationKeys
  }[]
}

type RecipesMap = {
  [key in Proteins]: RecipeType
}

export const frozenRecipes: RecipesMap = {
  [Proteins.BEEF]: {
    breadcrumb: 'recipes:frozen-v2.BEEF.breadcrumb',
    hero: {
      imageSrc: beefBowl,
      imageAlt: 'recipes:frozen-v2.BEEF.hero.image',
      title: 'recipes:frozen-v2.BEEF.hero.title',
      description: 'recipes:frozen-v2.BEEF.hero.description',
      features: [
        {
          certification: 'recipes:frozen-v2.BEEF.hero.certifications.0',
        },
        {
          certification: 'recipes:frozen-v2.BEEF.hero.certifications.1',
          disclaimer: 'recipes:frozen-v2.BEEF.hero.disclaimer',
        },
        {
          certification: 'recipes:frozen-v2.BEEF.hero.certifications.2',
          disclaimer: 'recipes:frozen-v2.disclaimer-antibiotics',
        },
        {
          certification: 'recipes:frozen-v2.BEEF.hero.certifications.3',
        },
      ],
      infoList: [
        {
          label: 'recipes:hero-v2.ingredients',
          description: 'recipes:ingredients-description',
        },
        {
          label: 'recipes:hero-v2.nutrition-information',
          description: 'recipes:frozen-v2.protein-nutrition-description.beef',
        },
        {
          label: 'recipes:hero-v2.protein-safety.beef',
          description: 'recipes:frozen-v2.safety-description',
        },
        {
          label: 'recipes:hero-v2.new-to-raw.frozen',
          description: 'recipes:frozen-v2.new-to-raw-description',
        },
      ],
      proteinPricing: 'recipes:frozen-v2.BEEF.hero.pricing',
      nutrition: NUTRITION_PATTIES[Proteins.BEEF],
    },
    benefits: {
      title: 'recipes:frozen-v2.BEEF.benefits.title',
      subtitle: 'recipes:frozen-v2.BEEF.benefits.subtitle',
      list: [
        'recipes:frozen-v2.BEEF.benefits.list.0',
        'recipes:frozen-v2.BEEF.benefits.list.1',
        'recipes:frozen-v2.BEEF.benefits.list.2',
        'recipes:frozen-v2.BEEF.benefits.list.3',
        'recipes:frozen-v2.BEEF.benefits.list.4',
      ],
      imageSrc: beefDisplay,
      imageAlt: 'recipes:frozen-v2.BEEF.benefits.image',
    },
    ingredients: [
      {
        label: 'recipes:individual.ingredients.beef-heart.label',
        description: 'recipes:individual.ingredients.beef-heart.info',
      },
      {
        label: 'recipes:individual.ingredients.beef-liver.label',
        description: 'recipes:individual.ingredients.beef-liver.info',
      },
      {
        label: 'recipes:individual.ingredients.beef-kidney.label',
        description: 'recipes:individual.ingredients.beef-kidney.info',
      },
      {
        label: 'recipes:individual.ingredients.beef-bone.label',
        description: 'recipes:individual.ingredients.beef-bone.info',
      },
      {
        label: 'recipes:individual.ingredients.vitamin.label',
        description: 'recipes:individual.ingredients.vitamin.info',
      },
      {
        label: 'recipes:individual.ingredients.kelp.label',
        description: 'recipes:individual.ingredients.kelp.info',
      },
    ],
  },
  [Proteins.CHICKEN]: {
    breadcrumb: 'recipes:frozen-v2.CHICKEN.breadcrumb',
    hero: {
      imageSrc: chickenBowl,
      nutrition: NUTRITION_PATTIES[Proteins.CHICKEN],
      imageAlt: 'recipes:frozen-v2.CHICKEN.hero.image',
      title: 'recipes:frozen-v2.CHICKEN.hero.title',
      description: 'recipes:frozen-v2.CHICKEN.hero.description',
      features: [
        {
          certification: 'recipes:frozen-v2.CHICKEN.hero.certifications.0',
        },
        {
          certification: 'recipes:frozen-v2.CHICKEN.hero.certifications.1',
        },
        {
          certification: 'recipes:frozen-v2.CHICKEN.hero.certifications.2',
          disclaimer: 'recipes:frozen-v2.disclaimer-antibiotics',
        },
        {
          certification: 'recipes:frozen-v2.CHICKEN.hero.certifications.3',
        },
      ],
      infoList: [
        {
          label: 'recipes:hero-v2.ingredients',
          description: 'recipes:ingredients-description',
        },
        {
          label: 'recipes:hero-v2.nutrition-information',
          description: 'recipes:frozen-v2.nutrition-description',
        },
        {
          label: 'recipes:hero-v2.safety',
          description: 'recipes:frozen-v2.safety-description',
        },
        {
          label: 'recipes:hero-v2.new-to-raw.frozen',
          description: 'recipes:frozen-v2.new-to-raw-description',
        },
      ],
      proteinPricing: 'recipes:frozen-v2.CHICKEN.hero.pricing',
    },
    benefits: {
      title: 'recipes:frozen-v2.CHICKEN.benefits.title',
      subtitle: 'recipes:frozen-v2.CHICKEN.benefits.subtitle',
      list: [
        'recipes:frozen-v2.CHICKEN.benefits.list.0',
        'recipes:frozen-v2.CHICKEN.benefits.list.1',
        'recipes:frozen-v2.CHICKEN.benefits.list.2',
        'recipes:frozen-v2.CHICKEN.benefits.list.3',
      ],
      imageSrc: chickenPouch,
      imageAlt: 'recipes:frozen-v2.CHICKEN.benefits.image',
    },
    ingredients: [
      {
        label: 'recipes:individual.ingredients.chicken-heart.label',
        description: 'recipes:individual.ingredients.chicken-heart.info',
      },
      {
        label: 'recipes:individual.ingredients.chicken-backs.label',
        description: 'recipes:individual.ingredients.chicken-backs.info',
      },
      {
        label: 'recipes:individual.ingredients.chicken-leg.label',
        description: 'recipes:individual.ingredients.chicken-leg.info',
      },
      {
        label: 'recipes:individual.ingredients.chicken-liver.label',
        description: 'recipes:individual.ingredients.chicken-liver.info',
      },
      {
        label: 'recipes:individual.ingredients.vitamin.label',
        description: 'recipes:individual.ingredients.vitamin.info',
      },
      {
        label: 'recipes:individual.ingredients.kelp.label',
        description: 'recipes:individual.ingredients.kelp.info',
      },
    ],
  },
  [Proteins.LAMB]: {
    breadcrumb: 'recipes:frozen-v2.LAMB.breadcrumb',
    hero: {
      imageSrc: lambBowl,
      nutrition: NUTRITION_PATTIES[Proteins.LAMB],
      imageAlt: 'recipes:frozen-v2.LAMB.hero.image',
      title: 'recipes:frozen-v2.LAMB.hero.title',
      description: 'recipes:frozen-v2.LAMB.hero.description',
      features: [
        {
          certification: 'recipes:frozen-v2.LAMB.hero.certifications.0',
        },
        {
          certification: 'recipes:frozen-v2.LAMB.hero.certifications.1',
        },
        {
          certification: 'recipes:frozen-v2.LAMB.hero.certifications.2',
          disclaimer: 'recipes:frozen-v2.disclaimer-antibiotics',
        },
        {
          certification: 'recipes:frozen-v2.LAMB.hero.certifications.3',
        },
      ],
      infoList: [
        {
          label: 'recipes:hero-v2.ingredients',
          description: 'recipes:ingredients-description',
        },
        {
          label: 'recipes:hero-v2.nutrition-information',
          description: 'recipes:frozen-v2.nutrition-description',
        },
        {
          label: 'recipes:hero-v2.safety',
          description: 'recipes:frozen-v2.safety-description',
        },
        {
          label: 'recipes:hero-v2.new-to-raw.frozen',
          description: 'recipes:frozen-v2.new-to-raw-description',
        },
      ],
      proteinPricing: 'recipes:frozen-v2.LAMB.hero.pricing',
    },
    benefits: {
      title: 'recipes:frozen-v2.LAMB.benefits.title',
      subtitle: 'recipes:frozen-v2.LAMB.benefits.subtitle',
      list: [
        'recipes:frozen-v2.LAMB.benefits.list.0',
        'recipes:frozen-v2.LAMB.benefits.list.1',
        'recipes:frozen-v2.LAMB.benefits.list.2',
        'recipes:frozen-v2.LAMB.benefits.list.3',
      ],
      imageSrc: lambPouch,
      imageAlt: 'recipes:frozen-v2.LAMB.benefits.image',
    },
    ingredients: [
      {
        label: 'recipes:individual.ingredients.lamb.label',
        description: 'recipes:individual.ingredients.lamb.info',
      },
      {
        label: 'recipes:individual.ingredients.beef-heart.label',
        description: 'recipes:individual.ingredients.beef-heart.info',
      },
      {
        label: 'recipes:individual.ingredients.beef-liver.label',
        description: 'recipes:individual.ingredients.beef-liver.info',
      },
      {
        label: 'recipes:individual.ingredients.beef-kidney.label',
        description: 'recipes:individual.ingredients.beef-kidney.info',
      },
      {
        label: 'recipes:individual.ingredients.beef-bone.label',
        description: 'recipes:individual.ingredients.beef-bone.info',
      },
      {
        label: 'recipes:individual.ingredients.vitamin.label',
        description: 'recipes:individual.ingredients.vitamin.info',
      },
      {
        label: 'recipes:individual.ingredients.kelp.label',
        description: 'recipes:individual.ingredients.kelp.info',
      },
    ],
  },
  [Proteins.DUCK]: {
    breadcrumb: 'recipes:frozen-v2.DUCK.breadcrumb',
    hero: {
      imageSrc: duckBowl,
      imageAlt: 'recipes:frozen-v2.DUCK.hero.image',
      title: 'recipes:frozen-v2.DUCK.hero.title',
      description: 'recipes:frozen-v2.DUCK.hero.description',
      features: [
        {
          certification: 'recipes:frozen-v2.DUCK.hero.certifications.0',
        },
        {
          certification: 'recipes:frozen-v2.DUCK.hero.certifications.1',
        },
        {
          certification: 'recipes:frozen-v2.DUCK.hero.certifications.2',
          disclaimer: 'recipes:frozen-v2.disclaimer-antibiotics',
        },
        {
          certification: 'recipes:frozen-v2.DUCK.hero.certifications.3',
        },
      ],
      infoList: [
        {
          label: 'recipes:hero-v2.ingredients',
          description: 'recipes:ingredients-description',
        },
        {
          label: 'recipes:hero-v2.nutrition-information',
          description: 'recipes:frozen-v2.nutrition-description',
        },
        {
          label: 'recipes:hero-v2.safety',
          description: 'recipes:frozen-v2.safety-description',
        },
        {
          label: 'recipes:hero-v2.new-to-raw.frozen',
          description: 'recipes:frozen-v2.new-to-raw-description',
        },
      ],
      proteinPricing: 'recipes:frozen-v2.DUCK.hero.pricing',
      nutrition: NUTRITION_PATTIES[Proteins.DUCK],
    },
    benefits: {
      title: 'recipes:frozen-v2.DUCK.benefits.title',
      subtitle: 'recipes:frozen-v2.DUCK.benefits.subtitle',
      list: [
        'recipes:frozen-v2.DUCK.benefits.list.0',
        'recipes:frozen-v2.DUCK.benefits.list.1',
        'recipes:frozen-v2.DUCK.benefits.list.2',
        'recipes:frozen-v2.DUCK.benefits.list.3',
      ],
      imageSrc: duckPouch,
      imageAlt: 'recipes:frozen-v2.DUCK.benefits.image',
    },
    ingredients: [
      {
        label: 'recipes:individual.ingredients.duck.label',
        description: 'recipes:individual.ingredients.duck.info',
      },
      {
        label: 'recipes:individual.ingredients.turkey-gizzards.label',
        description: 'recipes:individual.ingredients.turkey-gizzards.info',
      },
      {
        label: 'recipes:individual.ingredients.turkey-tails.label',
        description: 'recipes:individual.ingredients.turkey-tails.info',
      },
      {
        label: 'recipes:individual.ingredients.turkey-liver.label',
        description: 'recipes:individual.ingredients.turkey-liver.info',
      },
      {
        label: 'recipes:individual.ingredients.vitamin.label',
        description: 'recipes:individual.ingredients.vitamin.info',
      },
      {
        label: 'recipes:individual.ingredients.kelp.label',
        description: 'recipes:individual.ingredients.kelp.info',
      },
    ],
  },
  [Proteins.TURKEY]: {
    breadcrumb: 'recipes:frozen-v2.TURKEY.breadcrumb',
    hero: {
      nutrition: NUTRITION_PATTIES[Proteins.TURKEY],
      imageSrc: turkeyBowl,
      imageAlt: 'recipes:frozen-v2.TURKEY.hero.image',
      title: 'recipes:frozen-v2.TURKEY.hero.title',
      description: 'recipes:frozen-v2.TURKEY.hero.description',
      features: [
        {
          certification: 'recipes:frozen-v2.TURKEY.hero.certifications.0',
        },
        {
          certification: 'recipes:frozen-v2.TURKEY.hero.certifications.1',
        },
        {
          certification: 'recipes:frozen-v2.TURKEY.hero.certifications.2',
          disclaimer: 'recipes:frozen-v2.disclaimer-antibiotics',
        },
        {
          certification: 'recipes:frozen-v2.TURKEY.hero.certifications.3',
        },
      ],
      infoList: [
        {
          label: 'recipes:hero-v2.ingredients',
          description: NUTRITION_PATTIES[Proteins.TURKEY].ingredients,
        },
        {
          label: 'recipes:hero-v2.nutrition-information',
          description: 'recipes:frozen-v2.protein-nutrition-description.turkey',
        },
        {
          label: 'recipes:hero-v2.protein-safety.turkey',
          description: 'recipes:frozen-v2.safety-description',
        },
        {
          label: 'recipes:hero-v2.new-to-raw.frozen',
          description: 'recipes:frozen-v2.new-to-raw-description',
        },
      ],
      proteinPricing: 'recipes:frozen-v2.TURKEY.hero.pricing',
    },
    benefits: {
      title: 'recipes:frozen-v2.TURKEY.benefits.title',
      subtitle: 'recipes:frozen-v2.TURKEY.benefits.subtitle',
      list: [
        'recipes:frozen-v2.TURKEY.benefits.list.0',
        'recipes:frozen-v2.TURKEY.benefits.list.1',
        'recipes:frozen-v2.TURKEY.benefits.list.2',
        'recipes:frozen-v2.TURKEY.benefits.list.3',
      ],
      imageSrc: turkeyPouch,
      imageAlt: 'recipes:frozen-v2.TURKEY.benefits.image',
    },
    ingredients: [
      {
        label: 'recipes:individual.ingredients.turkey-tails.label',
        description: 'recipes:individual.ingredients.turkey-tails.info',
      },
      {
        label: 'recipes:individual.ingredients.turkey-gizzards.label',
        description: 'recipes:individual.ingredients.turkey-gizzards.info',
      },
      {
        label: 'recipes:individual.ingredients.turkey-necks.label',
        description: 'recipes:individual.ingredients.turkey-necks.info',
      },
      {
        label: 'recipes:individual.ingredients.turkey-liver.label',
        description: 'recipes:individual.ingredients.turkey-liver.info',
      },
      {
        label: 'recipes:individual.ingredients.vitamin.label',
        description: 'recipes:individual.ingredients.vitamin.info',
      },
      {
        label: 'recipes:individual.ingredients.kelp.label',
        description: 'recipes:individual.ingredients.kelp.info',
      },
    ],
  },
  [Proteins.VENISON]: {
    breadcrumb: 'recipes:frozen-v2.VENISON.breadcrumb',
    hero: {
      imageSrc: lambBowl,
      imageAlt: 'recipes:frozen-v2.VENISON.hero.image',
      title: 'recipes:frozen-v2.VENISON.hero.title',
      description: 'recipes:frozen-v2.VENISON.hero.description',
      features: [
        {
          certification: 'recipes:frozen-v2.VENISON.hero.certifications.0',
        },
        {
          certification: 'recipes:frozen-v2.VENISON.hero.certifications.1',
        },
        {
          certification: 'recipes:frozen-v2.VENISON.hero.certifications.2',
          disclaimer: 'recipes:frozen-v2.disclaimer-antibiotics',
        },
        {
          certification: 'recipes:frozen-v2.VENISON.hero.certifications.3',
        },
      ],
      infoList: [
        {
          label: 'recipes:hero-v2.ingredients',
          description: 'recipes:ingredients-description',
        },
        {
          label: 'recipes:hero-v2.nutrition-information',
          description: 'recipes:frozen-v2.nutrition-description',
        },
        {
          label: 'recipes:hero-v2.safety',
          description: 'recipes:frozen-v2.safety-description',
        },
        {
          label: 'recipes:hero-v2.new-to-raw.frozen',
          description: 'recipes:frozen-v2.new-to-raw-description',
        },
      ],
      proteinPricing: 'recipes:frozen-v2.VENISON.hero.pricing',
      nutrition: NUTRITION_PATTIES[Proteins.VENISON],
    },
    benefits: {
      title: 'recipes:frozen-v2.VENISON.benefits.title',
      subtitle: 'recipes:frozen-v2.VENISON.benefits.subtitle',
      list: [
        'recipes:frozen-v2.VENISON.benefits.list.0',
        'recipes:frozen-v2.VENISON.benefits.list.1',
        'recipes:frozen-v2.VENISON.benefits.list.2',
        'recipes:frozen-v2.VENISON.benefits.list.3',
        'recipes:frozen-v2.VENISON.benefits.list.4',
      ],
      imageSrc: venisonPouch,
      imageAlt: 'recipes:frozen-v2.VENISON.benefits.image',
    },
    ingredients: [
      {
        label: 'recipes:individual.ingredients.venison.label',
        description: 'recipes:individual.ingredients.venison.info',
      },
      {
        label: 'recipes:individual.ingredients.beef-heart.label',
        description: 'recipes:individual.ingredients.beef-heart.info',
      },
      {
        label: 'recipes:individual.ingredients.beef-liver.label',
        description: 'recipes:individual.ingredients.beef-liver.info',
      },
      {
        label: 'recipes:individual.ingredients.beef-kidney.label',
        description: 'recipes:individual.ingredients.beef-kidney.info',
      },
      {
        label: 'recipes:individual.ingredients.beef-bone.label',
        description: 'recipes:individual.ingredients.beef-bone.info',
      },
      {
        label: 'recipes:individual.ingredients.vitamin.label',
        description: 'recipes:individual.ingredients.vitamin.info',
      },
      {
        label: 'recipes:individual.ingredients.kelp.label',
        description: 'recipes:individual.ingredients.kelp.info',
      },
    ],
  },
}
